import { BaseDB } from 'projects/app-core/src/app/posts/model/BaseDB';

export interface EmailTemplate extends BaseDB {
  templateHtmlContent: string;
  htmlFileUrl: string;
  subject: string;
  title: string;
  bannerImageUrl: string;
  thumbnailImageUrl: string;
  bodyContent: string;
  ctaText: string;
  ctaLink: string;
  footerMessage: string;
  description: string;
  status: EmailTemplateStatus;
  tags: string[];
  allPartnersApplicable: boolean;
  applicablePartnerIds?: string[];
  isVisible: boolean;
}

export enum EmailTemplateStatus {
  PUBLISHED = 'published',
  ARCHIVED = 'archived',
  DRAFT = 'draft',
}
